import type { SubmitSuccessEventDetail } from '@stopen-helpers/static'
import { Dispatch, SetStateAction } from 'react'
import { ValidationError } from 'yup'

/**
 * @description
 * takes the Event object from a SUBMIT_SUCCESS event and clears the errors array
 * if there are no errors related to this fieldName
 * @memberof ValidationMessage
 * */
export const onSubmitSuccess = (
    event: CustomEvent<SubmitSuccessEventDetail>,
    formId: string,
    setValidationErrors: Dispatch<SetStateAction<ValidationError[]>>,
) => {
    if (formId !== event.detail.formId) {
        return
    }
    setValidationErrors([])
}
